import Immutable from 'immutable';
import { combineReducers } from 'redux-immutable';

import { CHAT_DESCRIBE_SHOW, CHAT_DESCRIBE_HIDE, CHAT_DESCRIBE_EMAIL_SUCCESS } from './actions';

const initialEmailState = Immutable.Map({
  success: false,
  address: null,
});

const email = (state = initialEmailState, action) => {
  switch (action.type) {
    case CHAT_DESCRIBE_EMAIL_SUCCESS: {
      return state.set('success', true).set('address', action.email);
    }
    default: {
      return state;
    }
  }
};

const show = (state = false, action) => {
  switch (action.type) {
    case CHAT_DESCRIBE_SHOW: {
      return true;
    }
    case CHAT_DESCRIBE_HIDE: {
      return false;
    }
    default: {
      return state;
    }
  }
};

export default combineReducers({
  show,
  email,
});
